import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { pdfjs } from 'react-pdf';
import { PdfViewerNavigation } from './PdfViewerNavigation';
import { PdfViewer } from './PdfViewer';
import {
  TransformComponent,
  TransformWrapper,
} from '@pronestor/react-zoom-pan-pinch';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export function PdfViewerContainer({ url, pdfViewerNavigationFixed }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const handleOnDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const goToPrevPage = () =>
    setPageNumber(pageNumber - 1 <= 1 ? 1 : pageNumber - 1);

  const goToNextPage = () =>
    setPageNumber(pageNumber + 1 >= numPages ? numPages : pageNumber + 1);

  return (
    <Box sx={{ height: '100%' }}>
      <PdfViewerNavigation
        goToPrevPage={goToPrevPage}
        goToNextPage={goToNextPage}
        pdfViewerNavigationFixed={pdfViewerNavigationFixed}
      />
      <Box
        sx={{
          width: '100%',
          height: '100%',
          overflowX: 'hidden',
          overflowY: 'auto',
          '.react-transform-wrapper': {
            width: '100%',
            height: '100%',
            overflow: 'unset',
          },
          '.react-transform-wrapper .react-transform-component': {
            width: '100%',
            height: '100%',
          },
        }}
      >
        <TransformWrapper centerOnInit={true}>
          <TransformComponent wrapperStyle={{ width: '100%', hight: '100%' }}>
            <PdfViewer
              url={url}
              pageNumber={pageNumber}
              onDocumentLoadSuccess={handleOnDocumentLoadSuccess}
            />
          </TransformComponent>
        </TransformWrapper>
      </Box>
    </Box>
  );
}
